import { Group, Stack } from '@mantine/core';
import { randomId } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import FormInputGroup from 'components/forms/FormInputGroup';
import P2Medium from 'components/typography/P2Medium';
import { ColumnPairingModalProvider } from 'components/forms/remote-source/config/chastia-config-form/device-types/columns/ColumnPairingProvider';
import DeviceTypePairingRow from 'components/forms/remote-source/config/chastia-config-form/device-types/DeviceTypePairingRow';
import { ChastiaConfigForm } from 'components/forms/remote-source/config/types';
import Button from 'components/Button';

interface DeviceTypesProps {
  form: ChastiaConfigForm;
}

/**
 * Sub-form for Device Type Column Pairings.
 */
export default function DeviceTypes({ form }: DeviceTypesProps) {
  return (
    <ColumnPairingModalProvider>
      <FormInputGroup groupTitle="Mapovanie Typov Zariadení">
        <Stack spacing={8}>
          <Group className="grid max-w-[1216px] grid-cols-[1fr_24px_1fr_288px] items-center gap-y-0">
            <P2Medium>ID Chastia</P2Medium>
            <div></div>
            <P2Medium>Typ Zariadenia</P2Medium>
          </Group>
          {form.values.types.map((item, index) => (
            <DeviceTypePairingRow key={item.key} form={form} item={item} index={index} />
          ))}
          <Group mt={8}>
            <Button
              size="md"
              leftIcon={<IconPlus />}
              onClick={() => form.insertListItem('types', { key: randomId(), columns: [] })}
            >
              Pridať riadok
            </Button>
          </Group>
        </Stack>
      </FormInputGroup>
    </ColumnPairingModalProvider>
  );
}
